module.exports = __webpack_public_path__ + "img/model3.2f264648.png";